"use strict";

var _Icon, _Text;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { c as _c } from "react/compiler-runtime";
import { PhoneFlatIcon } from '@autoguru/icons';
import { Box, Icon, Text, useMedia } from '@autoguru/overdrive';
import { useState } from 'react';
import { SupportHeaderModal } from './SupportHeaderModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const SupportHeader = () => {
  const $ = _c(22);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["desktop"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [isDesktop] = useMedia(t0, false);
  const [showModal, setShowModal] = useState(false);
  let t1;
  if ($[1] !== showModal) {
    t1 = () => {
      setShowModal(!showModal);
    };
    $[1] = showModal;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const changeState = t1;
  const t2 = isDesktop ? "1" : "none";
  let t3;
  if ($[3] !== changeState) {
    t3 = () => changeState();
    $[3] = changeState;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isDesktop ? "3" : "none";
  const t5 = isDesktop ? "4" : "none";
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
      size: "medium",
      icon: PhoneFlatIcon
    }));
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t5) {
    t7 = /*#__PURE__*/_jsx(Box, {
      marginRight: t4,
      paddingLeft: t5,
      children: t6
    });
    $[6] = t4;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== isDesktop) {
    t8 = isDesktop ? _Text || (_Text = /*#__PURE__*/_jsx(Text, {
      colour: "dark",
      children: "Support"
    })) : void 0;
    $[9] = isDesktop;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t7 || $[14] !== t8) {
    t9 = /*#__PURE__*/_jsxs(Box, {
      as: "a",
      borderWidthLeft: t2,
      borderColour: "light",
      display: "flex",
      onClick: t3,
      children: [t7, t8]
    });
    $[11] = t2;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== changeState || $[17] !== showModal) {
    t10 = /*#__PURE__*/_jsx(SupportHeaderModal, {
      showModal: showModal,
      changeState: changeState
    });
    $[16] = changeState;
    $[17] = showModal;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = /*#__PURE__*/_jsxs(_Fragment, {
      children: [t9, t10]
    });
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};